import * as React from 'react';
import { Classes, Dialog, H4, Intent, Spinner, Text } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { TranslatedMessage } from '../translation';
import { TLCode } from '../../../common/enums';

const SpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  color: red;
  flex-direction: column;
`;

interface FileLoadingModalProps extends WithTranslateProps {
  fileIsLoading: boolean;
  modalOpened: boolean;
  errors: string[];
  onClosed: () => void;
  titleFileLoadingTranslationCode: TLCode;
}

@observer
class FileLoadingModal extends React.Component<FileLoadingModalProps> {
  render() {
    const { fileIsLoading, modalOpened, errors, onClosed, titleFileLoadingTranslationCode } = this.props;

    return (
      <Dialog
        isOpen={modalOpened}
        onClose={onClosed}
        canOutsideClickClose={false}
        title={<TranslatedMessage id={titleFileLoadingTranslationCode} />}
      >
        {fileIsLoading ? (
          <SpinnerContainer>
            <Spinner intent={Intent.PRIMARY} size={Spinner.SIZE_STANDARD} />
          </SpinnerContainer>
        ) : (
          <div className={Classes.DIALOG_BODY}>
            {(errors === undefined || errors.length === 0) && (
              <TranslatedMessage id={TLCode.FILE_UPLOAD_SUCCESSFULLY_IMPORT} />
            )}
            {errors !== undefined && errors.length !== 0 && (
              <>
                <H4>
                  <TranslatedMessage id={TLCode.FILE_UPLOAD_ERROR_MESSAGE} />
                </H4>
                <ErrorContainer>
                  {errors.map((test: string, index) => {
                    return <Text key={index}>{test}</Text>;
                  })}
                </ErrorContainer>
              </>
            )}
          </div>
        )}
      </Dialog>
    );
  }
}

export default withTranslate(FileLoadingModal);
